"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storesContext = void 0;
var react_1 = __importDefault(require("react"));
var UserStore_1 = __importDefault(require("stores/UserStore"));
var QueriesStore_1 = require("stores/QueriesStore");
var PrefsStore_1 = __importDefault(require("../stores/PrefsStore"));
var CustomerPrefsStore_1 = __importDefault(require("../stores/CustomerPrefsStore"));
var AuthorisationsStore_1 = require("stores/AuthorisationsStore");
var UsersStore_1 = require("../stores/UsersStore");
var QueryPageStore_1 = __importDefault(require("../stores/QueryPageStore"));
var CustomersStore_1 = require("../stores/CustomersStore");
var CustomerPageStore_1 = __importDefault(require("../stores/CustomerPageStore"));
exports.storesContext = react_1.default.createContext({
    userStore: UserStore_1.default,
    queriesStore: new QueriesStore_1.QueriesStore([]),
    prefsStore: PrefsStore_1.default,
    authorisationsStore: new AuthorisationsStore_1.AuthorisationStore([]),
    customersStore: new CustomersStore_1.CustomersStore([]),
    usersStore: new UsersStore_1.UsersStore([]),
    queryPageStore: QueryPageStore_1.default,
    customerPrefsStore: CustomerPrefsStore_1.default,
    customerPageStore: CustomerPageStore_1.default,
});
